module.exports = __webpack_public_path__ + "img/tyregate.70fc9ff1.png";